<span *ngIf="showError()">
    {{ getError() }}
</span>